<template>
  <section class="timeTplListAddAndEdit p-4">
    <section>
      <viewTitle
        v-if="$route.params.id"
        :showReturn="true"
        title="业务管理 / 基础数据管理 / 预约时间模板 / 修改模板"
      />
      <viewTitle
        v-else
        :showReturn="true"
        title="业务管理 / 基础数据管理 / 预约时间模板 / 新增模板"
      />
    </section>

    <div class="main">
      <el-form label-width="150px" style="width: 650px">
        <el-form-item label="模板名称" required>
          <el-input
            v-model="timeTpObj.name"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效时间范围" required>
          <div class="full100">
            <el-radio
              v-model="timeTpObj.timeType"
              class="elRadio1"
              label="1"
              @change="
                () => {
                  timeTpObj.timeRang = [];
                }
              "
            >永久有效
            </el-radio
            >
            <el-radio v-model="timeTpObj.timeType" label="2">自定义</el-radio>
            <el-date-picker
              v-model="timeTpObj.timeRang"
              :disabled="timeTypeDisable"
              class="w100"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="法定节假日" required>
          <el-radio v-model="timeTpObj.holidayType" class="elRadio1" label="2"
          >不使用
          </el-radio
          >
          <el-radio v-model="timeTpObj.holidayType" label="1"
          >自动根据法定节假日修正
          </el-radio
          >
        </el-form-item> -->
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                所选择的日期会被剔除，不会生成预约号源，<br />
                且此项的运算权重比法定节假日、重复设置高。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            排除所选日期
          </div>
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.delDay"
                :key="tag"
                closable
                @close="() => delDelDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              ref="delDayTimePlugin"
              v-model="delDayTimePlugin"
              class="delDayTimePlugin"
              placeholder="选择日期"
              prefix-icon="el-icon-plus"
              type="date"
              @blur="delDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addDelDay"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                所选择的日期会被额外加入至“有效时间范围”内，<br />
                且此项的运算权重比法定节假日、重复设置高，<br />
                与“排除所选日期”权重相同。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            添加额外日期
          </div>
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.addDay"
                :key="tag"
                closable
                @close="() => delAddDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              ref="addDayTimePlugin"
              v-model="addDayTimePlugin"
              class="addDayTimePlugin"
              placeholder="选择日期"
              prefix-icon="el-icon-plus"
              type="date"
              @blur="addDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addAddDay"></i>
          </div>
        </el-form-item>
        <el-form-item label="重复设置" required>
          <div>
            <el-checkbox-group v-model="timeTpObj.checkList">
              <el-checkbox label="1">周一</el-checkbox>
              <el-checkbox label="2">周二</el-checkbox>
              <el-checkbox label="3">周三</el-checkbox>
              <el-checkbox label="4">周四</el-checkbox>
              <el-checkbox label="5">周五</el-checkbox>
              <el-checkbox label="6">周六</el-checkbox>
              <el-checkbox label="0">周日</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="每日号源划分" required>
          <div class="c4b">
            <div class="sourceResult">
              <span class="desc"> 总号源数： </span>
              <span
                v-if="
                  allSourceText1 === 0 &&
                    allSourceText2 === '存在不限号设置' &&
                    timeTpObj.daySource.length > 0
                "
                class="desc"
              >
                不限号
              </span>
              <span v-else class="desc">
                {{ allSourceText1 }}
                {{ allSourceText2 === "" ? "" : `(${allSourceText2})` }}
              </span>

              <template v-for="(item, index) in timeTpObj.daySource">
                <el-tag
                  :key="index"
                  closable
                  type="info"
                  @click="
                    () => {
                      editSource(item, index);
                    }
                  "
                  @close="
                    () => {
                      delDaySource(index);
                    }
                  "
                >
                  <span
                  >『 {{ item.begin_time }} 至 {{ item.end_time }} 』</span
                  >
                  <span
                    v-for="(group, index) in item.group_number"
                    :key="index"
                    style="margin-right: 10px"
                  >
                    <span>{{ getGrouoName(group.group_id) }}</span>
                    <span
                    >({{
                        Number(group.number) == 0 ? "不限" : group.number
                      }})</span
                    >
                  </span>
                </el-tag>
              </template>
            </div>
            <i class="el-icon-plus addDay" @click="addSource"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                此项是指用户发起车辆预约选择预约时间时，<br />
                必须提前多长时间。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span style="color: red">*</span>
            最小可预约时间
          </div>
          <el-select
            v-model="timeTpObj.minRangKey"
            :disabled="disabledSelect"
            placeholder="请选择最小须提前多长时间发起预约"
          >
            <el-option
              v-for="item in timeTpObj.minRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="subsrcComfig">
            <el-form style="width: 100px">
              <el-checkbox v-model="checked" @change="checkboxFn"
              >手动配置
              </el-checkbox
              >
            </el-form>

            <el-input
              v-model="timeInput.timeImport"
              :disabled="disabledTime"
              class="timeFormat"
              placeholder="请输入整数"
            ></el-input>
            <span>分钟</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                此项是指用户发起车辆预约选择预约时间时，<br />
                最大可提前多少天预约。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span style="color: red">*</span>
            最大可预约时间
          </div>
          <el-select
            v-model="timeTpObj.maxRangKey"
            placeholder="请选择最大可发起多长时间内的预约"
          >
            <el-option
              v-for="item in timeTpObj.maxRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="timeTpObj.textarea"
            :rows="4"
            placeholder="请输入备注（限500个字符）"
            type="textarea"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="排队登记可延迟时间" required>
          <el-input-number
          placeholder="请输入可延迟的小时数"
          class="inputNumber w-96"
          :step="1"
          step-strictly
          v-model="timeTpObj.check_effectivity_time"
          controls-position="right"
          :min="0"
          :controls="false"
        ></el-input-number>
        <span class="ml-2">小时</span>
        </el-form-item>
        <el-form-item label="叫号后过期时间" required>
          <el-input-number
          placeholder="请输入可延迟的小时数"
          class="inputNumber w-96"
          :step="1"
          step-strictly
          v-model="timeTpObj.calling_effectivity_time"
          controls-position="right"
          :min="0"
          :controls="false"
        ></el-input-number>
        <span class="ml-2">分钟</span>
        </el-form-item>
      </el-form>

      <div style="margin: 30px 0px 0px">
        <el-popover
          v-model="timeTpObj.visible"
          placement="bottom-start"
          style="margin-right: 20px"
          title="确认提醒"
          trigger="manual"
          width="370"
        >
          <template>
            <p>
              确认要{{
                $route.params.id ? "修改" : "创建"
              }}模板吗？确认前请先核实全部信息是否正确无误！
            </p>
            <div style="text-align: right; margin: 34px 0px 0px">
              <el-button
                slot="reference"
                size="small"
                @click="timeTpObj.visible = false"
              >
                取 消
              </el-button>
              <el-button size="small" type="primary" @click="saveTmp">
                确 定
              </el-button>
            </div>
          </template>
          <el-button
            slot="reference"
            size="small"
            type="primary"
            @click="saveCheck"
          >
            {{ $route.params.id ? "确认修改" : "确认创建" }}
          </el-button>
        </el-popover>

        <!-- <el-button type="primary" @click="saveTmp">{{
          $route.params.id ? "确认修改" : "确认创建"
        }}</el-button> -->
      </div>

      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>模板名称：</span></el-col>
        <el-col :span="14">
          <el-input
            v-model="timeTpObj.name"
            placeholder="请输入内容"
          ></el-input>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>有效时间范围：</span></el-col>
        <el-col :span="14">
          <div class="full100">
            <el-radio
              v-model="timeTpObj.timeType"
              label="1"
              class="elRadio1"
              @change="
                () => {
                  timeTpObj.timeRang = [];
                }
              "
              >永久有效</el-radio
            >
            <el-radio v-model="timeTpObj.timeType" label="2">自定义</el-radio>
            <el-date-picker
              :disabled="timeTypeDisable"
              v-model="timeTpObj.timeRang"
              type="daterange"
              value-format="yyyyMMDD"
              format="yyyy-MM-DD"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="w100"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>法定节假日：</span></el-col>
        <el-col :span="14">
          <el-radio v-model="timeTpObj.holidayType" label="1" class="elRadio1"
            >不使用</el-radio
          >
          <el-radio v-model="timeTpObj.holidayType" label="2"
            >自动根据法定节假日修正</el-radio
          >
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>排除日期：</span></el-col>
        <el-col :span="14">
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.delDay"
                :key="tag"
                closable
                @close="() => delDelDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="delDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="delDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="delDayTimePlugin"
              @blur="delDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addDelDay"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>添加额外日期：</span></el-col>
        <el-col :span="14">
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.addDay"
                :key="tag"
                closable
                @close="() => delAddDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="addDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="addDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="addDayTimePlugin"
              @blur="addDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addAddDay"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>重复设置：</span></el-col>
        <el-col :span="14">
          <div>
            <el-checkbox-group v-model="timeTpObj.checkList">
              <el-checkbox label="1">星期一</el-checkbox>
              <el-checkbox label="2">星期二</el-checkbox>
              <el-checkbox label="3">星期三</el-checkbox>
              <el-checkbox label="4">星期四</el-checkbox>
              <el-checkbox label="5">星期五</el-checkbox>
              <el-checkbox label="6">星期六</el-checkbox>
              <el-checkbox label="0">星期日</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>每日号源划分：</span></el-col>
        <el-col :span="14">
          <div class="c4b">
            <div class="sourceResult">
              <span class="desc"
                >总号源树：{{ allSourceText1 }}(<span>{{ allSourceText2 }}</span
                >)</span
              >
              <template v-for="(item, index) in timeTpObj.daySource">
                <el-tag
                  :key="index"
                  @click="
                    () => {
                      editSource(item, index);
                    }
                  "
                  type="info"
                  closable
                  @close="
                    () => {
                      delDaySource(index);
                    }
                  "
                >
                  <div>{{ item.begin_time }} ~ {{ item.end_time }}</div>
                  <span
                    v-for="(group, index) in item.group_number"
                    :key="index"
                  >
                    <span>{{ getGrouoName(group.group_id) }}</span>
                    <span
                      >({{
                        Number(group.number) == 0 ? "不限" : group.number
                      }})</span
                    >
                  </span>
                </el-tag>
              </template>
            </div>
            <i class="el-icon-plus addDay" @click="addSource"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>最小可预约时间：</span></el-col>
        <el-col :span="14">
          <el-select
            v-model="timeTpObj.minRangKey"
            placeholder="请选择最小可预约时间"
          >
            <el-option
              v-for="item in timeTpObj.minRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>最大可预约时间：</span></el-col>
        <el-col :span="14">
          <el-select
            v-model="timeTpObj.maxRangKey"
            placeholder="请选择最大可预约时间"
          >
            <el-option
              v-for="item in timeTpObj.maxRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>备注：</span></el-col>
        <el-col :span="14">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            v-model="timeTpObj.textarea"
          >
          </el-input>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"></el-col>
        <el-col :span="10">
          <el-button type="primary" @click="saveTmp">{{
            $route.params.id ? "确认修改" : "确认创建"
          }}</el-button>
          <el-button @click="backList">返回</el-button>
        </el-col>
      </el-row> -->
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$route.params.id ? '修改每日号源划分' : '添加每日号源划分'"
      :visible.sync="dialogVisible"
      class="elDialog"
      width="670px"
    >
      <div>
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="4">
            <span style="color: red">*</span>
            <span>时间段</span>
          </el-col>
          <el-col :span="20">
            <el-time-picker
              v-model="sourceobj.timeRang"
              end-placeholder="结束时间"
              format="HH:mm"
              is-range
              placeholder="选择时间范围"
              range-separator="至"
              start-placeholder="开始时间"
              value-format="HH:mm"
            >
            </el-time-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="4">
            <span style="color: red">*</span>
            <span>划分模式</span>
          </el-col>
          <el-col :span="20">
            <el-radio-group v-model="sourceobj.allot_type" @change="onAllotTypeChange">
              <el-radio :label="1">按整体划分</el-radio>
              <el-radio :label="2">按车辆业务类型</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <template v-for="(business, index) in sourceobj.businessArr">
          <el-row :key="index" :gutter="20" type="flex">
            <el-col :span="4">
              <span style="color: red">*</span>
              <span v-if="Number(index) == 0">预约业务</span>
            </el-col>
            <el-col :span="20">
              <div class="divRow">
                <el-select
                  v-model="business.opKey"
                  clearable
                  placeholder="请选择业务组"
                  @change="
                    val => {
                      opKeyChange();
                    }
                  "
                >
                  <el-option
                    v-for="item in businessList"
                    v-show="sourceobj.opKeyList.indexOf(item.id) < 0"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-radio v-model="business.timeType" class="elRadio1" label="1" @change=" () => { business.sum = ''; }">数量不限</el-radio>
                <el-radio v-model="business.timeType" class="elRadio1" label="2" @change="handleLimitSums(index)">限定数量</el-radio>
                <el-input v-if="Number(business.timeType) == 2" v-model="business.sum" placeholder="数量"></el-input>
                <el-input v-else v-model="business.sum" disabled placeholder="数量"></el-input>
                <i class="el-icon-close close" @click=" () => { businessDel(index); }"></i>
                <template v-if="sourceobj.allot_type === 2 && business.opKey">
                  <section style="padding: 10px 0 0;" v-for="item in getGrouoItem(business.opKey).sub_business_list" :key="item.id">
                    <el-input style="width: 200px;" :value="item.name" readonly></el-input>
                    <el-input @input="handleLimitSums(index)" v-model="business.detail[item.id]" placeholder="数量"></el-input>
                  </section>
                </template>
              </div>
            </el-col>
          </el-row>
        </template>
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="4">
            <span v-if="sourceobj.businessArr.length == 0">预约业务</span>
          </el-col>
          <el-col :span="20">
            <div class="divRow">
              <i class="el-icon-plus plus" @click="businessAdd"></i>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="comfireSourceobj">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
import moment from "moment";

export default {
  props: {},
  data() {
    return {
      carTypes: [
        { name: "平板车", key: "flatTruck" },
        { name: "货柜车", key: "containerTruck" },
        { name: "槽罐车", key: "tankTruck" },
        { name: "高栏车", key: "highSidedTruck" },
        { name: "其他", key: "orderTruck" }
      ],
      businessItems: {},
      timeTpObj: {
        visible: false,
        name: "",
        timeType: "",
        timeRang: [],
        delDay: [],
        addDay: [],
        checkList: [],
        holidayType: "",
        minRangList: [
          {
            value: "0",
            label: "0分钟 无时间限制"
          },
          {
            value: "1800",
            label: "不小于30分钟"
          },
          {
            value: "3600",
            label: "不小于1小时(推荐)"
          },
          {
            value: "7200",
            label: "不小于2小时"
          },
          {
            value: "10800",
            label: "不小于3小时"
          },
          {
            value: "14400",
            label: "不小于4小时"
          },
          {
            value: "18000",
            label: "不小于5小时"
          }
        ],
        maxRangList: [
          {
            value: "1",
            label: "1天内"
          },
          {
            value: "2",
            label: "2天内"
          },
          {
            value: "3",
            label: "3天内"
          },
          {
            value: "7",
            label: "7天内(推荐)"
          },
          {
            value: "15",
            label: "15天内"
          },
          {
            value: "30",
            label: "30天内"
          }
        ],
        options: [],
        textarea: "",
        minRangKey: "",
        maxRangKey: "",
        daySource: [],
        dataArr: {}
      },
      dialogVisible: false,
      businessList: [],
      sourceobj: {
        allot_type: 1,
        timeRang: ["08:00", "09:00"],
        opKeyList: [],
        businessArr: [
          {
            opKey: "",
            timeType: "",
            sum: "",
            detail: {}
          }
        ],
        index: ""
      },
      delDayTimePlugin: "",
      addDayTimePlugin: "",
      allSourceText1: 0,
      allSourceText2: "",
      checked: false, //默认不选中手动配置
      disabledTime: true, //true的时候手动输入为默认禁止
      timeInput: {
        timeImport: "" //初始默认值
      }, //手动配置时间
      disabledSelect: false, //下拉默认为可使用
      dataVal: [], //最小预约时间手写的值
      dataLabel: [], //最小预约时间下拉的值
      minRingData: "", //后端返回最小预约时间的值
      checkboxVal: "", //true选择， false不选中
    };
  },
  components: { viewTitle },
  computed: {
    getGrouoName() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item.name;
          }
        }
      };
    },
    getGrouoItem() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item;
          }
        }
      };
    },
    handleMap() {
      return (array = [], key = 'id') => {
        let map = {};
        for (let i = 0;i < array.length; i++) {
          map[array[i][key]] = array[i]
        }
        return map
      }
    },
    timeTypeDisable() {
      console.log("12323423");
      return this.timeTpObj.timeType == "2" ? false : true;
    }
    // allSourceText1() {
    //   let t1 = 0;
    //   this.timeTpObj.daySource.forEach(item => {
    //     item.group_number.forEach(item1 => {
    //       t1 += Number(item1.number);
    //     });
    //   });
    //   return t1;
    // },
    // allSourceText2() {
    //   let t2 = "";
    //   this.timeTpObj.daySource.forEach(item => {
    //     item.group_number.forEach(item1 => {
    //       if (Number(item1.number) == 0) {
    //         t2 = "存在不限号设置";
    //       }
    //     });
    //   });
    //   return t2;
    // }
  },
  methods: {
    onAllotTypeChange() {
      for (let i = 0;i < this.sourceobj.businessArr.length;i++) {
        this.sourceobj.businessArr[i].detail = {}
      }
    },
    getInitData(id) {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_time_model_detail",
          data: {
            id
          }
        })
        .then(res => {
          const data = res.data.data;
          this.dataArr = data;
          this.timeTpObj.name = data.name;
          this.timeTpObj.timeType = data.is_permanent_valid.toString();
          this.minRingData = data.min_booking_time;
          if (data.is_permanent_valid.toString() == "2") {
            this.timeTpObj.timeRang = [
              data.begin_time.toString(),
              data.end_time.toString()
            ];
          } else {
            this.timeTpObj.timeRang = [];
          }
          this.timeTpObj.allot_type = data.allot_type;
          this.timeTpObj.holidayType = "2";
          this.timeTpObj.addDay = data.exclude_day;
          this.timeTpObj.delDay = data.extra_day;
          this.timeTpObj.checkList = data.repeat_setting;
          // if (this.$router.params.id) {
          //   this.timeTpObj.minRangKey = "0";
          // }
          this.timeInput.timeImport = data.min_booking_time.toString();
          this.timeTpObj.minRangKey = data.min_booking_time.toString();
          this.timeTpObj.maxRangKey = data.max_booking_day.toString();
          this.timeTpObj.textarea = data.note;
          this.timeTpObj.check_effectivity_time = data.check_effectivity_time;
          this.timeTpObj.calling_effectivity_time = data.calling_effectivity_time;
          this.timeTpObj.daySource = data.periods;
          this.setAllSource();
          this.minDataListFn();
        });
    },
    getBusinessList() {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_group",
          data: {
            keyword: "",
            state: 1,
            page_size: 1000
          }
        })
        .then(res => {
          this.businessList = res.data.data.data;
        });
    },
    addDelDay() {
      this.$refs["delDayTimePlugin"].focus();
    },
    delDayTimePluginBlur(time) {
      if (time.value === "") {
        return false;
      }
      let timeVal = moment(time.value).format("YYYY-MM-DD");
      if (this.timeTpObj.delDay.indexOf(timeVal) < 0) {
        this.timeTpObj.delDay.push(timeVal);
      }
    },
    addAddDay() {
      this.$refs["addDayTimePlugin"].focus();
    },
    addDayTimePluginBlur(time) {
      if (time.value === "") {
        return false;
      }
      let timeVal = moment(time.value).format("YYYY-MM-DD");
      if (this.timeTpObj.addDay.indexOf(timeVal) < 0) {
        this.timeTpObj.addDay.push(timeVal);
      }
      this.delDayTimePlugin = "";
    },
    delDelDay(index) {
      this.timeTpObj.delDay.splice(index, 1);
    },
    delAddDay(index) {
      this.timeTpObj.addDay.splice(index, 1);
    },
    addSource() {
      this.dialogVisible = true;
      this.sourceobj.timeRang = ["08:00", "09:00"];
      this.sourceobj.allot_type = 1;
      this.sourceobj.opKeyList = [];
      this.sourceobj.businessArr = [
        {
          opKey: "",
          timeType: "",
          sum: "",
          detail: {}
        }
      ];
      this.sourceobj.index = "";
    },
    businessDel(index) {
      this.sourceobj.businessArr.splice(index, 1);
      this.opKeyChange();
    },
    businessAdd() {
      this.sourceobj.businessArr.push({
        opKey: "",
        timeType: "",
        sum: "",
        detail: {}
      });
    },
    opKeyChange() {
      let opKeyList = [];
      this.sourceobj.businessArr.forEach(item => {
        opKeyList.push(item.opKey);
        console.log(this.getGrouoItem(item.opKey));

      });
      this.sourceobj.opKeyList = [...new Set(opKeyList)];
    },
    comfireSourceobj() {
      let groupNumber = [];
      for (let i = 0; i < this.sourceobj.businessArr.length; i++) {
        let item = this.sourceobj.businessArr[i];
        if (item.opKey.trim() === "") {
          this.$common.pcToastFail(`请选择第${i + 1}项的业务组`);
          return false;
        }
        if (item.timeType.trim() === "") {
          this.$common.pcToastFail(`请选择第${i + 1}项的业务组数量设置方式`);
          return false;
        }

        // let detail = item.detail || {};
        // let truck_total = 0;
        // for (let j = 0;j < this.carTypes.length; j++) {
        //   let ragex = /^\d+$/;
        //   if (!(detail[this.carTypes[j].key] >= 0 && ragex.test(detail[this.carTypes[j].key]))) {
        //     if (detail[this.carTypes[j].key] == '') {
        //       if (Number(item.timeType) == 2) {
        //         this.$common.pcToastFail(`第${i + 1}项的${this.carTypes[j].name}不能为非0或非正整数`);
        //         return false;
        //       }
        //     } else {
        //       this.$common.pcToastFail(`第${i + 1}项的${this.carTypes[j].name}不能为非0或非正整数`);
        //       return false;
        //     }
        //   }
        //   truck_total += +detail[this.carTypes[j].key]
        // }

        // if (Number(item.timeType) === 2) {
        //   // if (item.sum === "") {
        //   //   this.$common.pcToastFail(`第${i + 1}项的限定数量不能为空`);
        //   //   return false;
        //   // }
        //   // if (!Number(item.sum) && Number(item.sum) !== 0) {
        //   //   this.$common.pcToastFail(`第${i + 1}项的限定数量不能为非数字值`);
        //   //   return false;
        //   // }
        //   // if (String(item.sum).indexOf(".") > 0) {
        //   //   this.$common.pcToastFail(`第${i + 1}项的限定数量必须为正整数`);
        //   //   return false;
        //   // }
        //   if (Number(item.sum) < 1 || Number(item.sum) > 999) {
        //     this.$common.pcToastFail(`第${i + 1}项的限定数量范围为1~999`);
        //     return false;
        //   }
        //   if (truck_total != +item.sum) {
        //     this.$common.pcToastFail(`第${i + 1}项业务组的车型号源总数不等于限定数量`);
        //     return false
        //   }
        // }
      }
      console.log("nihao ");
      this.dialogVisible = false;
      this.sourceobj.businessArr.forEach(item => {
        let detail = item.detail || {};
        let new_detail = {};
        for (let key in detail) {
          if (detail[key]) {
            new_detail[key] = detail[key]
          }
          // if (detail[key] == '') {
          //   new_detail[key] = -1
          // } else {
          //   new_detail[key] = detail[key]
          // }
        }
        groupNumber.push({
          group_id: item.opKey,
          number: Number(item.timeType) == 1 ? 0 : item.sum,
          detail: new_detail
        });
      });
      let daySource = {
        begin_time: this.sourceobj.timeRang[0],
        end_time: this.sourceobj.timeRang[1],
        group_number: groupNumber,
        allot_type: this.sourceobj.allot_type
      };
      daySource = JSON.parse(JSON.stringify(daySource));
      if (this.sourceobj.index.toString().length > 0) {
        this.timeTpObj.daySource[Number(this.sourceobj.index)] = daySource;
      } else {
        this.timeTpObj.daySource.push(daySource);
      }
      this.setAllSource();
    },
    setAllSource() {
      // 总号源数
      let t1 = 0;
      this.timeTpObj.daySource.forEach(item => {
        item.group_number.forEach(item1 => {
          t1 += Number(item1.number);
        });
      });
      this.allSourceText1 = t1;
      // 是否存在不限号设置
      let t2 = "";
      this.timeTpObj.daySource.forEach(item => {
        item.group_number.forEach(item1 => {
          if (Number(item1.number) == 0) {
            t2 = "存在不限号设置";
          }
        });
      });
      this.allSourceText2 = t2;
    },
    editSource(item, index) {
      this.dialogVisible = true;
      this.sourceobj.opKeyList = [];
      this.sourceobj.businessArr = [];
      this.sourceobj.allot_type = item.allot_type;
      this.sourceobj.timeRang = [item.begin_time, item.end_time];
      item.group_number.forEach(group => {

        this.sourceobj.opKeyList.push(group.group_id);
        const { detail = {} } = group;
        let params = {
          opKey: group.group_id,
          timeType: Number(group.number) == 0 ? "1" : "2",
          sum: Number(group.number) > 0 ? group.number : "",
          detail: {}
        }
        for (let item in detail) {
          // let new_item = detail[item] == -1 ? '' : detail[item]
          // params.detail[item] = new_item
          if (detail[item]) {
            params.detail[item] = detail[item]
          }
        }

        this.sourceobj.businessArr.push(params);
      });
      this.sourceobj.index = index;
    },
    delDaySource(index) {
      this.timeTpObj.daySource.splice(index, 1);
      this.setAllSource();
    },
    saveCheck() {
      if (this.timeTpObj.name.trim() === "") {
        this.$common.pcToastFail(`请输入模板名称`);
        return false;
      }
      if (this.timeTpObj.timeType.trim() === "") {
        this.$common.pcToastFail(`请选择有效时间范围`);
        return false;
      }
      if (
        Number(this.timeTpObj.timeType.trim()) === 2 &&
        this.timeTpObj.timeRang.length !== 2
      ) {
        this.$common.pcToastFail(`请设置有效时间的自定义范围`);
        return false;
      }
      // if (this.timeTpObj.holidayType.trim() === "") {
      //   this.$common.pcToastFail(`请选择是否使用自动根据法定节假日修正`);
      //   return false;
      // }
      if (this.timeTpObj.checkList.length === 0) {
        this.$common.pcToastFail(`至少选择一个重复设置的时间`);
        return false;
      }
      if (this.timeTpObj.daySource.length === 0) {
        this.$common.pcToastFail(`请设置每日号源划分`);
        return false;
      }

      // if (this.timeTpObj.minRangKey.trim() === "") {
      //   this.$common.pcToastFail(`请选择最小可预约时间`);
      //   return false;
      // }
      if (this.timeTpObj.maxRangKey.trim() === "") {
        this.$common.pcToastFail(`请选择最大可预约时间`);
        return false;
      }
      if (this.checked === true) {
        if (!/^[1-9]+[0-9]*$/.test(this.timeInput.timeImport.trim())) {
          this.$common.pcToastFail(`请输入正整数`);
          return false;
        }
      } else if (this.checked === true) {
        if (this.timeTpObj.minRangKey.trim() === "") {
          this.disabledTime === true;
          this.$common.pcToastFail(`请选择最小可预约时间`);
          return false;
        }
      }
      // if (this.checked === false) {
      //   if (this.timeInput.timeImport.toString().trim() == "") {
      //     this.$common.pcToastFail(`请输入正整数`);
      //   }
      //   return false;
      // }
      // check_effectivity_time
      // calling_effectivity_time
      if (!this.timeTpObj.check_effectivity_time && this.timeTpObj.check_effectivity_time != 0) {
        this.$common.pcToastFail(`请输入排队登记可延迟时间`);
        return false;
      }
      if (!this.timeTpObj.calling_effectivity_time && this.timeTpObj.calling_effectivity_time != 0) {
        this.$common.pcToastFail(`请输入叫号后过期时间`);
        return false;
      }
      this.timeTpObj.visible = true;
    },
    saveTmp() {
      this.timeTpObj.visible = false;
      let data = {
        id: this.$route.params.id || "",
        name: this.timeTpObj.name,
        is_permanent_valid: Number(this.timeTpObj.timeType),
        begin_time: this.timeTpObj.timeRang[0] || "",
        end_time: this.timeTpObj.timeRang[1] || "",
        allot_type: this.timeTpObj.allot_type,
        is_use_statutory_holidays: '2',
        exclude_day: JSON.stringify(this.timeTpObj.addDay),
        extra_day: JSON.stringify(this.timeTpObj.delDay),
        repeat_setting: JSON.stringify(this.timeTpObj.checkList),
        min_booking_time: this.checked
          ? this.timeInput.timeImport * 60
          : this.timeTpObj.minRangKey,
        max_booking_day: this.timeTpObj.maxRangKey,
        note: this.timeTpObj.textarea,
        period_number: JSON.stringify(this.timeTpObj.daySource),
        check_effectivity_time: this.timeTpObj.check_effectivity_time,
        calling_effectivity_time: this.timeTpObj.calling_effectivity_time
      };
      console.log(data);
      this.$common
        .http({
          url: "/api/queue/admin/save_business_time_model",
          data: data
        })
        .then(res => {
          if (this.$route.params.id) {
            this.$common.pcToastSuccess("修改成功");
            this.$router.replace({
              path: "/rhqy/service/appoint/timeTplList/detail/" + res.data.data
            });
          } else {
            this.$common.pcToastSuccess("创建成功");
            // this.$router.replace({
            //   path: "/rhqy/service/appoint/timeTplList"
            // });
          }
          this.$router.go(-1);
        });
    },
    backList() {
      this.$router.go(-1);
    },
    // 选择checkbox的事件  手动配置 @change="checkboxFn"
    checkboxFn(val) {
      console.log(val, "选择的值");
      this.checkboxVal = val;
      if (val === true) {
        this.timeTpObj.minRangKey = "";
      } else {
        this.timeInput.timeImport = "";
      }
      this.disabledSelect = !this.disabledSelect;
      this.disabledTime = !this.disabledTime;
    },
    // selectCheck(val) {
    //   this.checkVal = val;
    //   console.log(this.$route.params.id, "aaaaaaaa");
    //   console.log(val, "选中了");

    //   if (val === "0") {
    //     this.checked = true;
    //     this.disabledTime = false;
    //   } else {
    //     this.checked = false;
    //     this.disabledTime = true;
    //   }
    //   this.timeInput.timeImport = "";
    // }

    // 修改模板最小预约时间-----修改
    minDataListFn() {
      const minListData = [];
      const minListValue = [];
      this.timeTpObj.minRangList.forEach(item => {
        minListData.push(item.value);
        minListValue.push(item.label);
      });
      this.dataVal = minListData;
      this.dataLabel = minListValue;

      let flag = this.dataVal.includes(String(this.minRingData));
      if (flag) {
        // 相同
        this.checked = false;
        this.timeTpObj.minRangKey = String(this.minRingData);
        this.disabledTime = true;
        this.disabledSelect = false;
        this.timeInput.timeImport = "";
      } else {
        // 不同
        this.checked = true;
        this.timeInput.timeImport = String(this.minRingData / 60);
        this.disabledTime = false;
        this.disabledSelect = true;
        this.timeTpObj.minRangKey = "";
      }
    },
    handleLimitSums(index) {
      let total = 0;
      for (let key in this.sourceobj.businessArr[index].detail) {
        total += +this.sourceobj.businessArr[index].detail[key]
      }
      this.sourceobj.businessArr[index].sum = total
    }
  },

  created() {
    this.getBusinessList();
    if (this.$route.params.id) {
      this.getInitData(this.$route.params.id);
      this.minDataListFn();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";

.timeTplListAddAndEdit {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  .main {
    padding: 16px;

    .el-row {
      padding-bottom: 18px;
    }

    .el-col-4 {
      text-align: right;
    }

    .elRadio1 {
      width: 70px;
    }

    .el-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }

    .addDay {
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
      height: 25px;
    }

    .c4b {
      padding: 5px 10px 0px 10px;
      border: 1px solid #cecece;
    }

    .full100 {
      display: flex;
      align-items: baseline;
      margin-top: 4px;

      .w100 {
        width: 100%;
      }
    }

    .dayDiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .el-select {
      width: 100%;
    }

    .sourceResult {
      .desc {
        display: inline-block;
      }

      .el-tag {
        display: inline-block;
        white-space: normal;
        height: auto;
        line-height: 17px;
        padding: 5px 28px 5px 8px;
        position: relative;
        width: 100%;
      }
    }
  }

  .elDialog {
    .el-row {
      padding-bottom: 18px;
    }

    .divRow {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .el-radio {
        margin-right: 10px;
      }

      .el-select {
        width: 200px;
        margin-right: 10px;
      }

      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }

    .el-col-4 {
      text-align: right;
    }

    .plus {
      color: #409eff;
      cursor: pointer;
    }

    .close {
      color: coral;
      cursor: pointer;
    }
  }
}
.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}
</style>
<style lang="less">
.timeTplListAddAndEdit {
  .el-date-editor .el-range-separator {
    line-height: 24px;
  }

  .sourceResult {
    .el-tag {
      .el-icon-close {
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }
    }
  }

  .delDayTimePlugin,
  .addDayTimePlugin {
    width: 0;
    opacity: 0;

    > input {
      border: 0 !important;
      padding: 0;
    }
  }
}

.subsrcComfig {
  display: flex;
  position: absolute;
  width: 100%;
  left: 100%;
  top: 0;
  margin-left: 20px;

  .timeFormat {
    margin: 0 20px 0 0;
    width: 105px;
  }
}
</style>
